import { user_preference } from '@Api';
import { TYPES } from '@Types';
import { inject, injectable } from 'inversify';
import { Locale, UserPreference, VersionInterface } from '@Models';
import { VersionGameMapper } from '@Mapper/ninthAge/VersionGameMapper';

@injectable()
export class UserPreferenceMapper {
  @inject(TYPES.Mapper.VersionGameMapper)
  private _versionGameMapper!: VersionGameMapper;

  public map(item: user_preference): UserPreference {
    return {
      id: item.id,
      email: item.email,
      name: item.name,
      game: this._versionGameMapper.map(item.game),
      builderInterface: this.mapInterface(item.builder_interface),
      useLatestVersion: item.use_latest_version,
      isGuest: item.is_guest,
      defaultLocale: this.mapLocale(item.default_locale),
      location: item.location
        ? { lat: item.location.latitude, lng: item.location.longitude }
        : null,
    } satisfies UserPreference as UserPreference;
  }

  public mapInterface(
    item: user_preference.builder_interface,
  ): VersionInterface {
    switch (item) {
      case user_preference.builder_interface.OLD_SKOOL:
        return VersionInterface.OldSkool;
    }
    return VersionInterface.Classic;
  }

  public mapLocale(item: user_preference.default_locale): Locale {
    switch (item) {
      case user_preference.default_locale.DE:
        return Locale.DE;
      case user_preference.default_locale.FR:
        return Locale.FR;
      case user_preference.default_locale.IT:
        return Locale.IT;
      case user_preference.default_locale.PL:
        return Locale.PL;
      case user_preference.default_locale.ES:
        return Locale.ES;
    }

    return Locale.EN;
  }
}
